export enum SortDirection {
  PriceAsc = 'price',
  PriceDesc = '-price',
  AlphaAsc = 'name',
  AlphaDesc = '-name',
  NewestFirst = '-available_on',
  OldestFirst = 'available_on',
}
